export const styles = {
  // Header Section
  headerContainer: {
    mb: 4
  },
  headerTitle: {
    color: 'primary.main',
    fontWeight: 700,
    mb: 1
  },
  headerSubtitle: {
    color: 'text.secondary',
    mb: 3
  },

  // Global Settings Section
  globalSettingsContainer: {
    p: 4,
    mb: 4,
    borderRadius: 3,
    border: '1px solid',
    borderColor: 'divider',
    boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
    background: 'linear-gradient(145deg, #2d3748 0%, #1a202c 100%)',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '4px',
      background: 'linear-gradient(90deg, #1976d2 0%, #42a5f5 50%, #90caf9 100%)',
    }
  },
  globalSettingsHeader: {
    display: 'flex',
    alignItems: 'center',
    mb: 4,
    gap: 2
  },
  globalSettingsIcon: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 16px rgba(25, 118, 210, 0.4)'
  },
  globalSettingsIconText: {
    color: 'white',
    fontSize: '1.5rem'
  },
  globalSettingsTitle: {
    color: 'white',
    fontWeight: 700,
    mb: 0.5
  },
  globalSettingsSubtitle: {
    color: 'rgba(255, 255, 255, 0.7)'
  },

  // Field Cards
  fieldCard: {
    p: 3,
    borderRadius: 2,
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
    }
  },
  captainFieldCard: {
    backgroundColor: 'rgba(25, 118, 210, 0.1)',
    border: '1px solid',
    borderColor: 'rgba(25, 118, 210, 0.3)',
    '&:hover': {
      boxShadow: '0 8px 25px rgba(25, 118, 210, 0.25)',
      borderColor: 'rgba(25, 118, 210, 0.5)',
      backgroundColor: 'rgba(25, 118, 210, 0.15)'
    }
  },
  viceCaptainFieldCard: {
    backgroundColor: 'rgba(156, 39, 176, 0.1)',
    border: '1px solid',
    borderColor: 'rgba(156, 39, 176, 0.3)',
    '&:hover': {
      boxShadow: '0 8px 25px rgba(156, 39, 176, 0.25)',
      borderColor: 'rgba(156, 39, 176, 0.5)',
      backgroundColor: 'rgba(156, 39, 176, 0.15)'
    }
  },
  contestTypeFieldCard: {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    border: '1px solid',
    borderColor: 'rgba(255, 255, 255, 0.1)',
    '&:hover': {
      boxShadow: '0 8px 25px rgba(255, 255, 255, 0.1)',
      borderColor: 'rgba(255, 255, 255, 0.2)',
      backgroundColor: 'rgba(255, 255, 255, 0.08)'
    }
  },

  // Field Headers
  fieldHeader: {
    display: 'flex',
    alignItems: 'center',
    mb: 2,
    gap: 1
  },
  fieldIcon: {
    fontSize: '1.2rem'
  },
  captainFieldLabel: {
    fontWeight: 600,
    color: '#90caf9'
  },
  viceCaptainFieldLabel: {
    fontWeight: 600,
    color: '#ce93d8'
  },
  contestTypeFieldLabel: {
    fontWeight: 600,
    color: 'rgba(255, 255, 255, 0.8)'
  },

  // Input Fields
  inputField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
      },
      '&.Mui-focused': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
      }
    },
    '& .MuiInputBase-input': {
      color: 'white',
      '&::placeholder': {
        color: 'rgba(255, 255, 255, 0.5)',
        opacity: 1
      }
    }
  },
  captainInputField: {
    '& .MuiOutlinedInput-root': {
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#90caf9',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#90caf9',
        borderWidth: 2,
      }
    }
  },
  viceCaptainInputField: {
    '& .MuiOutlinedInput-root': {
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ce93d8',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ce93d8',
        borderWidth: 2,
      }
    }
  },
  contestTypeInputField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'rgba(255, 255, 255, 0.03)',
      border: '1px solid rgba(255, 255, 255, 0.05)',
      '& .MuiInputBase-input': {
        color: 'rgba(255, 255, 255, 0.7)',
        fontWeight: 500
      }
    }
  },

  // Search Section
  searchContainer: {
    mb: 3,
    p: 3,
    backgroundColor: 'background.paper',
    borderRadius: 2,
    border: '1px solid',
    borderColor: 'divider',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
  },
  searchTitle: {
    mb: 2,
    color: 'primary.main',
    fontWeight: 600
  },
  searchInput: {
    maxWidth: 500,
    '& .MuiOutlinedInput-root': {
      borderRadius: 3,
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'primary.main',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'primary.main',
        borderWidth: 2,
      }
    }
  },
  searchResults: {
    mt: 2,
    p: 2,
    backgroundColor: 'primary.light',
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    gap: 1
  },
  searchResultsText: {
    color: 'primary.contrastText',
    fontWeight: 500
  },

  // Table Header
  tableHeader: {
    display: 'flex',
    px: 3,
    py: 2,
    backgroundColor: 'primary.main',
    borderRadius: '8px 8px 0 0',
    color: 'white',
    fontWeight: 600,
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  },
  tableHeaderCell: {
    color: 'white'
  },

  // Table Container
  tableContainer: {
    maxHeight: 1400,
    overflow: 'hidden',
    mb: 3,
    borderRadius: '0 0 8px 8px',
    border: '1px solid',
    borderColor: 'divider',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
  },

  // Empty State
  emptyStateContainer: {
    p: 4,
    textAlign: 'center',
    backgroundColor: 'background.default'
  },
  emptyStateTitle: {
    mb: 1,
    color: 'text.secondary'
  },
  emptyStateText: {
    color: 'text.secondary'
  },

  // Save Button Section
  saveButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    mt: 4,
    p: 3,
    backgroundColor: 'background.paper',
    borderRadius: 2,
    border: '1px solid',
    borderColor: 'divider',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
  },
  saveButton: {
    px: 4,
    py: 1.5,
    borderRadius: 3,
    fontWeight: 600,
    fontSize: '1rem',
    textTransform: 'none',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    '&:hover': {
      boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
      transform: 'translateY(-2px)',
    },
    '&:disabled': {
      transform: 'none',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    },
    transition: 'all 0.3s ease-in-out'
  },

  // Row Styling
  rowContainer: {
    px: 3,
    py: 1.5,
    borderBottom: '1px solid',
    borderColor: 'divider',
    alignItems: 'center',
    backgroundColor: 'background.paper',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: 'action.hover',
      transform: 'translateX(4px)',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    },
    '&:last-child': {
      borderBottom: 'none',
    }
  },
  eventNameText: {
    fontWeight: 500,
    color: 'text.primary',
    fontSize: '0.9rem'
  },
  statsGroupContainer: {
    px: 1.5,
    py: 0.5,
    backgroundColor: 'primary.light',
    borderRadius: 1,
    display: 'inline-block'
  },
  statsGroupText: {
    fontSize: '0.8rem',
    color: 'primary.main',
    fontWeight: 600,
    textTransform: 'capitalize'
  },
  rowInputField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'primary.main',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'primary.main',
        borderWidth: 2,
      }
    }
  },
  switchContainer: {
    margin: 0,
    '& .MuiFormControlLabel-label': {
      fontSize: '0.75rem',
      color: 'inherit'
    }
  },
  switchLabel: {
    fontSize: '0.75rem',
    fontWeight: 600
  },
  activeSwitchLabel: {
    color: 'success.main'
  },
  inactiveSwitchLabel: {
    color: 'text.secondary'
  },
  activeSwitch: {
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: 'success.main',
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: 'success.main',
    }
  }
}; 